'use strict';

/**
 * Collection of all carousel component related scripts
 */
var carousel = {};

// Model Includes
var CarouselModel = require('../model/carousel');

// Constants
var ATTRIBUTES = {
    DATA: {
        ID: 'id',
        CONFIG: 'data-carousel-config',
        IS_LOADED: 'data-is-carousel-loaded',
        OPTIONS: 'data-carousel-options'
    },
    CLASS: {
        CAROUSEL: '.com-carousel .experience-slides',
        OWL_STAGE: '.owl-stage',
        OWL_STAGE_OUTER: '.owl-stage-outer',
        NAVIGATION: '.owl-nav'
    },
    SLIDE_MARGIN_DESKTOP: 26.3 // This refers to the configured margin on the constants file.
};

/**
 * Checks if the `.owl-stage` is wider than `.owl-stage-outer` for a given carousel element,
 * and toggles the visibility of navigation arrows accordingly.
 * This is only applicable for Desktop since on Mobile there are no arrows on the carousel.
 *
 * @param {JQuery<HTMLElement>} $element - The carousel element.
 */
function checkOverflow($element) {
    const $stage = $element.find(ATTRIBUTES.CLASS.OWL_STAGE);
    const $outer = $element.find(ATTRIBUTES.CLASS.OWL_STAGE_OUTER);
    const $navigation = $element.find(ATTRIBUTES.CLASS.NAVIGATION);

    if ($stage.innerWidth() >= $outer.innerWidth() + ATTRIBUTES.SLIDE_MARGIN_DESKTOP) {
        $navigation.show();
    } else {
        $navigation.hide();
    }
}

/**
 * Initialize all carousel components.
 * @param {null | undefined | JQuery<HTMLElement>} _$carousels - initialize carousels.
 */
carousel.init = function (_$carousels) {
    // Constants
    var $carousels = $(ATTRIBUTES.CLASS.CAROUSEL);

    // Get carousels to initialize
    if (_$carousels !== null && _$carousels !== undefined && _$carousels.length) {
        $carousels = _$carousels;
    }

    // Initialize window global variable that stores all custom selects active in page
    if (!('comCustomCarousels' in window) || !Array.isArray(window.comCustomCarousels)) {
        window.comCustomCarousels = [];
    }

    $carousels.each(function (index, element) {
        // Constants
        const $ELEMENT = $(element);
        const ID = $ELEMENT.parent().attr(ATTRIBUTES.DATA.ID);
        const CONFIG = $ELEMENT.parent().attr(ATTRIBUTES.DATA.CONFIG) ? $ELEMENT.parent().attr(ATTRIBUTES.DATA.CONFIG) : 'default';

        // Create a new carousel instance
        const model = new CarouselModel($ELEMENT, ID, CONFIG);

        model.setCarousel();
        window.comCustomCarousels.push(model);
        $ELEMENT.attr(ATTRIBUTES.DATA.IS_LOADED, 'true');

        // Run the checkOverflow function initially
        checkOverflow($ELEMENT);

        // Run the checkOverflow function after the carousel is resized
        $ELEMENT.on('resized.owl.carousel', function () {
            checkOverflow($ELEMENT);
        });
    });
};

/**
 * Initialize a collection of carousels.
 * @param {JQuery<HTMLElement>} $carousels - to initialize
 */
$.carousel = function ($carousels) {
    carousel.init($carousels);
};

module.exports = carousel;
